import { useForm } from "@mantine/form";
import { TemProduct } from "../../../model/TemProduct";
import {
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Select,
  TextInput,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { IconCheck } from "@tabler/icons-react";
import { repositoryMdm, repositoryPos } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";

const CreateDataView = ({ onSuccess }: { onSuccess: any }) => {
  const [loadingButton, setLoadingButton] = useState<boolean>(false);
  const [dataCatSegment3c, setDataCatSegment3c] = useState<ComboboxItem[]>([]);

  const entity = {
    id: 0,
    maHang: null,
    temHacom: "",
    temDvt: "",
    createDate: null,
    createBy: null,
    lastUpdatedDate: null,
    lastUpdatedBy: null,
  };

  const form = useForm<TemProduct>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    validate: {
      maHang: (value: string | null) => {
        if (!value || value.length === 0) {
          return "Vui lòng chọn loại sản phẩm !";
        }
      },
      temHacom: (value: string, values) => {
        if (value.length === 0 && values.temDvt.length === 0) {
          return "Vui lòng nhập tem sản phẩm HACOM hoặc tem sản phẩm dịch vụ tốt !";
        }
      },
      temDvt: (value: string, values) => {
        if (value.length === 0 && values.temHacom.length === 0) {
          return "Vui lòng nhập tem sản phẩm dịch vụ tốt hoặc tem sản phẩm HACOM !";
        }
      },
    },
  });

  const getDataCatSegment3c = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblCatSegment3c/get-all"
    );

    if (res && res.success) {
      const data = res.data
        ?.filter((item: any) => item.codeString && item.name)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: String(item.codeString),
        }));
      setDataCatSegment3c(data);
    }
  };

  const handleSubmit = async (dataSubmit: TemProduct) => {
    setLoadingButton(true);
    const res = await repositoryMdm.post<MessageResponse<any>>(
      "/api/v1/TblTemItem/create",
      dataSubmit
    );

    if (res && res.success) {
      NotificationExtension.Success("Tạo mới tem sản phẩm thành công !");
      setTimeout(() => {
        onSuccess();
        modals.closeAll();
      }, 1000);
    } else {
      NotificationExtension.Fails(res?.message);
      setLoadingButton(false);
    }
  };

  useEffect(() => {
    getDataCatSegment3c();
  }, []);

  return (
    <Box
      component="form"
      m={"5px 0px"}
      w={"30vw"}
      maw={450}
      onSubmit={form.onSubmit((e: TemProduct) => {
        handleSubmit(e);
      })}
    >
      <Grid>
        <Grid.Col span={12}>
          <Select
            key={form.key("maHang")}
            label={"Loại sản phẩm"}
            placeholder="Nhập loại sản phẩm"
            data={dataCatSegment3c}
            searchable
            clearable
            nothingFoundMessage="Không tìm thấy dữ liệu !"
            withAsterisk
            {...form.getInputProps("maHang")}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <TextInput
            label="Tem HACOM"
            placeholder="Nhập Tem HACOM"
            withAsterisk={
              form.getValues().temDvt?.length === 0 &&
              form.getValues().temHacom?.length === 0
            }
            {...form.getInputProps("temHacom")}
            onChange={(e) => {
              form.setFieldValue("temHacom", e.currentTarget.value);
            }}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <TextInput
            label="Tem dịch vụ tốt"
            placeholder="Nhập Tem dịch vụ tốt"
            withAsterisk={
              form.getValues().temHacom?.length === 0 &&
              form.getValues().temDvt?.length === 0
            }
            {...form.getInputProps("temDvt")}
            onChange={(e) => {
              form.setFieldValue("temDvt", e.currentTarget.value);
            }}
          />
        </Grid.Col>
      </Grid>
      <Flex justify={"end"}>
        <Button
          loading={loadingButton}
          disabled={loadingButton}
          type="submit"
          color="teal"
          leftSection={<IconCheck size={16} />}
        >
          Lưu
        </Button>
      </Flex>
    </Box>
  );
};

export default CreateDataView;
